// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title[data-v-300549ec]{font-size:5rem;font-weight:700}@media (min-width:1024px){.title[data-v-300549ec]{font-size:8rem}}.title[data-v-300549ec]{line-height:5rem}@media (min-width:1024px){.title[data-v-300549ec]{line-height:7rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
